import content from "@/content/site-content.json";
import type { SiteContent } from "@/types/content";

const { initiatives } = content as SiteContent;

export default function Activities() {
  return (
    <section id="aktiviteter" className="section activities">
      <div className="container">
        <p className="eyebrow">{initiatives.eyebrow}</p>
        <h2>{initiatives.title}</h2>
        <p className="activities__intro">{initiatives.intro}</p>

        <ol className="activities__chain">
          {initiatives.items.map((item) => (
            <li key={item.title} className="activities__node">
              <span className="activities__dot" aria-hidden="true" />
              <div className="activities__card">
                <span className="activities__when">{item.when}</span>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>

      <style>{`
        .activities__intro {
          max-width: 60ch;
        }
        .activities__chain {
          list-style: none;
          margin: var(--space-4) 0 0;
          padding: 0;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: var(--space-2);
          position: relative;
        }
        .activities__chain::before {
          content: "";
          position: absolute;
          top: 10px;
          left: 5%;
          right: 5%;
          height: 3px;
          background: repeating-linear-gradient(
            to right,
            var(--color-line) 0 10px,
            transparent 10px 18px
          );
        }
        .activities__node {
          position: relative;
          padding-top: var(--space-3);
        }
        .activities__dot {
          position: absolute;
          top: 0;
          left: 0;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background: var(--color-terracotta);
          border: 4px solid var(--color-cream);
          box-shadow: 0 0 0 2px var(--color-line);
        }
        .activities__card {
          background: #fff;
          border: 1px solid var(--color-line);
          border-radius: var(--radius-md);
          padding: var(--space-2);
          height: 100%;
        }
        .activities__when {
          display: inline-block;
          font-family: var(--font-display);
          font-size: 0.78rem;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          color: var(--color-clay);
          margin-bottom: 0.4rem;
        }
        .activities__card h3 {
          font-size: var(--fs-h3);
          margin-bottom: 0.35rem;
        }
        .activities__card p {
          font-size: 0.95rem;
          color: var(--color-ink-soft);
          margin: 0;
        }
        @media (max-width: 860px) {
          .activities__chain {
            grid-template-columns: 1fr;
          }
          .activities__chain::before {
            display: none;
          }
        }
      `}</style>
    </section>
  );
}
